<template>
  <v-container>
    <v-row>
      <v-col xs="12" cols="12"  md="4">
        <v-list rounded>
          <v-subheader>Eduroam</v-subheader>
          <v-list-item-group v-model="active_num" color="#084776">
            <v-list-item v-for="(item, i) in items" :key="i" @click="active(item.num)">
              <v-list-item-icon>
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.text"></v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-col>
      <v-col xs="12" cols="12"  md="8">
        <div v-for="(item, i) in tekstovi" :key="i" v-if="active_num == item.num">
          <h2 style="color: #084776" >{{item.title}}</h2>
          <br />
          <p v-html="item.txt"></p>
        </div>
        <v-fade-transition mode="out-in">
          <router-view></router-view>
        </v-fade-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    item: 0,
    items: [
      { text: "Uvjeti korištenja", icon: "far fa-check-square", num: 0 },
      { text: "Arhitektura", icon: "fas fa-pencil-ruler", num: 1 },
      { text: "Reference", icon: "fas fa-link", num: 2 }
    ],
    active_num: 0,
    tekstovi: [
      {
        num: 0,
        title: "Uvjeti korištenja",
        txt: `eduroam usluga na Sveučilištu u Mostaru jedna je od usluga u okviru sustava AAI@SUM te se stoga pruža u skladu s <a>Pravilnikom o ustroju sustava AAI@SUM</a>.<br><br>
            Osim toga eduroam usluga u BiH dio je europske eduroam konfederacije koja je definirana sljedećim dokumentima: <br<<br>
            <ul>
               <li><a href="https://www.eduroam.org/wp-content/uploads/2016/05/GN3-12-194_eduroam-policy-for-signing_ver2-4_1_18052012.pdf" target="_blank" class="link">European Confederation eduroam policy</a> [pdf] Srpanj 2012</li>
               <li><a href="https://www.eduroam.org/wp-content/uploads/2016/05/GN3-12-192_eduroam-policy-service-definition_ver28_26072012.pdf" target="_blank" class="link">eduroam Service Definition</a> [pdf] Srpanj 2012</li>
            </ul>
            Europska eduroam konfederacija dio je globalne eduroam usluge (<a href="https://www.eduroam.org/" target="_blank" class="link">www.eduroam.org</a>).`
      },
      {
        num: 1,
        title: "Arhitektura usluge eduroam",
        txt: `<h3>Organizacija</h3>
            Globalna eduroam usluga je konfederacija, odnosno federacija u koju se uključuju kontinentalne i/ili nacionalne eduroam usluge sukladno utvrđenim pravilima.<br><br>
            Nacionalne eduroam federacije, održavane od strane nacionalnih istraživačkih i obrazovnih mrežnih organizacija (NREN) glavni su dijelovi konfederacije.<br><br>
            Radom globalne eduroam usluge koordinira <a href="https://www.eduroam.org/wp-content/uploads/TSec10015-GlobaleduroamGovernance-ConsensusVersion.pdf" target="_blank" class="link">GeGC</a>, a radom europske: eduroam SG u okviru projekta <a href="https://geant3plus.archive.geant.net/Pages/default.aspx" target="_blank" class="link">GÉANT</a>. <br><br>
            <h3>Tehnički ustroj</h3>
            eduroam se temelji na globalnoj hijerarhiji RADIUS poslužitelja te na korištenju IEEE 802.1x normi. Obje tehnologije RADIUS i 802.1x, provjerene su i u većini slučajeva već se upotrebljavaju na obrazovnim institucijama, čime je olakšano uvođenje eduroam usluge. Tehnički uvjeti definirani su u: <a href="https://www.eduroam.org/wp-content/uploads/2016/05/GN3-12-192_eduroam-policy-service-definition_ver28_26072012.pdf" target="_blank" class="link">eduroam Service Definition</a>.<br><br>
            Bitno je naglasiti kako korisnikove vjerodajnice (korisničko ime i lozinka) nisu poznate instituciji koju korisnik posjećuje, već samo njegovoj matičnoj instituciji čime se štiti privatnost krajnjeg korisnika.`
      },
      {
        num: 2,
        title: "Reference",
        txt: `<h3>Zanimljive poveznice</h3>
            <ul>
                <li><a href="https://wiki.geant.org/display/H2eduroam" target="_blank" class="link">eduroam How to... - Wiki</a></li>
                <li><a href="https://community.ja.net/library/janet-services-documentation/wireless-security" target="_blank" class="link">The JANET National User Group: Report on Wireless Security</a></li>
                <li><a href="https://www.cisco.com/c/en/us/td/docs/solutions/Enterprise/Mobility/secwlandg20/sw2dg/ch3_2_SPMb.html" target="_blank" class="link">802.1X authenticates 802.11 wireless</a></li>
                <li><a href="https://ccm.net/contents/798-802-1x-eap" target="_blank" class="link">Introducing 802.1x and EAP</a></li>
                <li><a href="https://www.eduroam.hr/docs/safwl_wp.pdf" target="_blank" class="link">Cisco SAFE: Wireless LAN Security in Depth</a></li>
                <li><a href="https://www.eduroam.hr/docs/authp_an.pdf" target="_blank" class="link">Authentication with 802.1x and EAP Across Congested WAN Links</a></li>
                <li><a href="https://www.eduroam.hr/docs/ir61.pdf" target="_blank" class="link">WLAN Roaming Guidelines (also known as Inter-Operator Handbook)</a> (V 3.0.0 April 2003) GSM Association Permanent Reference Document: IR.61</li>
                <li><a href="https://www.eduroam.hr/docs/se27.pdf" target="_blank" class="link">Services, Ease of Use, and Operator Considerations in Interworked WLAN-Cellular Systems</a> (V 3.0.0 28th May 2003) GSM Association Permanent Reference Document: SE.27</li>
                <li><a href="https://www.eduroam.hr/" target="_blank" class="link">Eduroam.hr - Srce</a></li>
            </ul>`
      }
    ],
    txt: ``
  }),
  methods: {
    active(data) {
      this.active_num = data;
    }
  }
};
</script>
